import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { BFC } from '@/shared/types';
import { Icon } from '@/shared/uikit/Icon';
import { Title } from '@/shared/uikit/Title';

type AiBannerProps = {
  title: string;
  description: string;
};

export const AiBanner: BFC<AiBannerProps> = ({ title, description }) => (
  <Container>
    <Icon name="sparkle" size="s20" style={{ color: COLORS.systemSky200 }} />
    <ContentWrapper>
      <div>
        <Title style={{ marginBottom: 8 }} bold size={16}>
          {title}
        </Title>
        <Description>{description}</Description>
      </div>
    </ContentWrapper>
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: start;
  gap: 12px;
  background-color: ${COLORS.systemSky100};
  border: 1px solid ${COLORS.systemSky200};
  border-radius: 8px;
  padding: 12px;
  width: 100%;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Description = styled.div`
  color: ${COLORS.systemDark200};
  font-size: 14px;
  line-height: 20px;
`;
